export default __webpack_public_path__ + "static/get-info-mobile-66c0ad00f6b605438c87ae0c6d2f7064.jpg";